import React, {useEffect, useState} from 'react'
import { CasoGeneralComponent } from 'reccol-caso-general'

import { useLocation } from 'react-router-dom'
import { obtenerDatosLlaves } from '../../store/actions/encargado-compania-action'
import { useDispatch, useSelector } from 'react-redux'

import { Auth, LoadingComponent} from 'recupero-comunes'
import { Card, Container } from 'react-bootstrap'
import { configuracionFormAction33 } from '../../store/actions/consutar-caso-action'
import MenuConsultas from './menu-consultas'
import MenuFlotanteDetalleCaso from './menu-flotante'
import { getAntecedentesCaso } from '../../api/api-consultar-caso';

const DetalleCaso = () => {
    const { roles } = Auth.currentUser()
    const [loading, setLoading]=useState(false)
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer)
    const {llaves} = data_encargado
    const {state}=useLocation()
    const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso:552
    const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado :1
    const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:8600399880
    const dispatch = useDispatch()
    const data_consulta = useSelector((state) => state.consultarCasosReducer)
    const { cfg_form33} = data_consulta

    const origen =state?.origen  ? state.origen:'consulta'

    const [antecedentesCaso, setAntecedentesCaso] = useState(null)
    const [reloadCaso, setReloadCaso] = useState(false)

    const [verBotoneraLateral, setVerBotoneraLateral]=useState(false)
    
    useEffect(() => {
        const tieneRol = roles?.some(r => r.rol === "0070ACTCASO") || false;
        setVerBotoneraLateral(tieneRol);
    }, [roles]);

    useEffect(()=>{
        
        dispatch(obtenerDatosLlaves({idCaso:idCasoLocation, idImplicado:idImplicado, idOrgCaso:idOrganizacionCaso}))

    },[dispatch])
    useEffect(() => {
        if (llaves) { 
            setLoading(true)
                let query = Buffer.from(JSON.stringify({
                    rutcia: llaves && llaves['idOrgCaso'],
                    idform: 33
                })).toString('base64')
                dispatch(configuracionFormAction33(query))
                .then(() => {
                    obtenerAntecedentesCaso();
                })                
                .then(()=>setLoading(false))
        }
     }, [dispatch, llaves, reloadCaso])

    const obtenerAntecedentesCaso = async () => {
        let query = Buffer.from(JSON.stringify({ idOrgCaso: llaves && llaves['idOrgCaso'], idCaso: llaves && llaves['idCaso'] })).toString('base64')
        const response = await getAntecedentesCaso(query);

        if (response) {
            setAntecedentesCaso(response);
        }
    };
    
    
    
    return (
        <div> 
             <LoadingComponent show={loading}/>
             <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >{
                                         cfg_form33 &&  `${cfg_form33.cfg_form33['detalleconsulta-title']}
                                         ${idCasoLocation}`}</Card.Header>
                <Card.Body>
                    <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso} detalles={true} reloadCaso={reloadCaso} /> 
                </Card.Body>
            </Card>
            </Container> 
            <MenuConsultas origen={origen} antecedentesCaso={antecedentesCaso}/>
            {verBotoneraLateral &&
                <MenuFlotanteDetalleCaso antecedentesCaso={antecedentesCaso} setReloadCaso={setReloadCaso}/>
            }
        </div>
    )
}

export default DetalleCaso
